import "../../../../../../lib/assets/javascripts/assert.js";

window.Sparkle ??= {};
window.Sparkle.WalkInAvailability ??= {};

Sparkle.WalkInAvailability.AvailabilityBadge = class AvailabilityBadge {
  constructor(resourceKey, templates, options) {
    this.update = this.update.bind(this);
    this.hideBadge = this.hideBadge.bind(this);
    this.showBadge = this.showBadge.bind(this);
    this.showBadgeCalls = this.showBadgeCalls.bind(this);
    this.renderNextOpenAt = this.renderNextOpenAt.bind(this);
    this.templates = templates;
    if (options == null) {
      options = {};
    }
    this.el = jQuery('<div class="walk-in-availability-badge" aria-label="Walk-in Availability">');

    jQuery.when().then(() => {
      if (this.options.update) {
        Sparkle.WalkInAvailability.observe(resourceKey, this.update);
      }
      return this.update(this.options.state);
    });
  }

  // PROTECTED

  update(state) {
    if (JSON.stringify(this.currentState) === JSON.stringify(state)) {
      return;
    }
    return (this.currentState = state);
  }

  hideBadge() {
    return this.el.empty();
  }

  cloneTemplate(template) {
    return jQuery(template.contents()).clone(true);
  }

  showBadge(badge, state) {
    const content = this.cloneTemplate(badge);
    this.showBadgeCalls(content, state); // these are overridden in child classes
    return this.el.html(content);
  }

  // override in child classes
  showBadgeCalls(content, state) {
    return null;
  }

  renderNextOpenAt(badge, nextOpenAt) {
    return badge.find("[data-next-open-at]").each(function () {
      let formats;
      if (!nextOpenAt) {
        return;
      }
      const format = jQuery(this).data("format");
      if (format) {
        formats = {
          sameDay: `[at] ${format}`,
          nextDay: `[tomorrow at] ${format}`,
          nextWeek: `dddd [at] ${format}`,
        };
      }

      return jQuery(this).html(`Opens ${moment.parseZone(nextOpenAt).calendar(null, formats)}`);
    });
  }
};
